import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll'
    }),
    title () {
      const modulo = this.modulos.find(x => x.tipo === this.pasoActual)
      if (modulo) {
        return this.getTexto('modulos.' + modulo.tipo + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
      }
      return ''
    },
    breadcrumbs () {
      let textoPasoActual = ''
      if (this.loadedAll) {
        let paso = this.modulos.find(x => x.tipo === this.pasoActual)
        if (paso) {
          textoPasoActual = this.getTexto('modulos.' + paso.tipo + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
        }
      }
      if (this.esAdministrador) {
        return [
          {
            text: this.$t('mixins.modulos.home'),
            exact: true,
            to: {name: 'home'}
          },
          {
            text: this.$t('mixins.modulos.reservas'),
            exact: true,
            to: {name: 'reservas.list'}
          },
          {
            text: this.$t('mixins.modulos.detalleReserva'),
            to: {
              name: 'reservas.id',
              params: {id: this.id}
            },
            exact: true
          },
          {
            text: textoPasoActual,
            disabled: true
          }
        ]
      } else {
        return [
          {
            text: this.$t('mixins.modulos.reservas'),
            exact: true,
            to: {name: 'reservas.list'}
          },
          {
            text: this.$t('mixins.modulos.detalleReserva'),
            to: {
              name: 'reservas.id',
              params: {id: this.id}
            },
            exact: true
          },
          {
            text: textoPasoActual,
            disabled: true
          }
        ]
      }
    }
  },
  methods:
  {
    getModuloEstado (tipo, reserva) {
      let color = 'aceptada'
      switch (tipo) {
        case 'condiciones':
          color = 'aceptada'
          break
        case 'pago':
          color = this.getColorEstado(reserva.estadoPago.codigoEstadoPago, tipo)
          break
        case 'firmakyc':
          color = !reserva.contratoKyc || !reserva.contratoKyc.documentoSinFirmar ? 'pendiente' : !reserva.contratoKyc.documentoFirmado ? 'revision' : 'aceptada'
          break
        case 'validacionDocumentacion':
          color = this.getColorEstado(reserva.estadoValidacionDocumentacion.codigoEstadoValidacionDocumentacion, tipo)
          break
        case 'contrato':
          if (reserva.modulosOrden.simplificada == 0) {
            color = this.getColorEstado(reserva.estadoContrato.codigoEstadoContrato, tipo)
          } else {
            color = !reserva.contrato || !reserva.contrato.documentoSinFirmar ? 'pendiente' : !reserva.contrato.documentoFirmado ? 'revision' : 'aceptada'
          }
          
          break
        case 'kyc':
          color = this.getColorEstado(reserva.estadoKyc.codigoEstadoKyc, tipo)
          break
        case 'documentacion':
          if (reserva.actorId) {
            color = this.getColorEstado(reserva.estadoDocumentacion.codigoEstadoDocumentacion, tipo)
          } else {
            if (reserva.estadoDocumentacion.codigoEstadoDocumentacion == 2) {
              color = this.getColorEstado(6, tipo)
            } else {
              color = this.getColorEstado(reserva.estadoDocumentacion.codigoEstadoDocumentacion, tipo)
            }
            
          }
          break
        case 'pbc':
          color = this.getColorEstado(reserva.estadoPbc.codigoEstadoPbc, tipo)
          break
      }
      return color
    },
    getModuloCodigo (tipo, reserva) {
      switch (tipo) {
        case 'condiciones':
          return 10
        case 'pago':
          return reserva.estadoPago.codigoEstadoPago
        case 'validacionDocumentacion':
          return reserva.estadoValidacionDocumentacion.codigoEstadoValidacionDocumentacion
        case 'contrato':
          return reserva.estadoContrato.codigoEstadoContrato
        case 'kyc':
          return reserva.estadoKyc.codigoEstadoKyc
        case 'documentacion':
          return reserva.estadoDocumentacion.codigoEstadoDocumentacion
        case 'pbc':
          return reserva.estadoPbc.codigoEstadoPbc
      }
    },
    confirmadoMail (reserva) {
      return reserva.actorConfirmacion !== null && reserva.actorConfirmacion.token == null
    },
    comprobarPasoReserva (tipo, reserva) {
      if (!this.confirmadoMail(reserva)) {
        this.error()
        this.addAlert({texto: this.$t('mixins.modulos.confirmarEmail'), color: 'error'})
        return
      }
      if (!this.comprobarEstadoActual(tipo, reserva)) {
        this.error()
        this.addAlert({texto: this.$t('mixins.modulos.accesoNoPermitido'), color: 'error'})
        return
      }
      if (!this.moduloTerminado(tipo, reserva) && !this.comprobarEstadoAnterior(tipo, reserva)) {
        this.error()
        this.addAlert({texto: this.$t('mixins.modulos.completarPasos'), color: 'error'})
        this.$router.push({name: 'reservas.id', params: {id: this.id}})
      } else {
        this.loadedAll = true
      }
    },
    comprobarEstadoConBorrado (modulo, reserva) {
      let codigoActual = this.getModuloCodigo(modulo, reserva)
      // Eliminada y/o caducada y sin completar
      if (
        (
          reserva.estado === 91 || reserva.estado === 90 || reserva.estado === 93 ||
          (reserva.fechaLimite != null && moment().isAfter(reserva.fechaLimite))
        ) && codigoActual !== 10 && codigoActual !== 11 && codigoActual !== 20
      ) {
        return false
      }
      return true
    },
    comprobarEstadoActual (modulo, reserva) {
      if (!reserva.sincronizada) {
        return false
      }
      let indiceActual = this.modulos.findIndex(x => x.tipo === modulo)
      if (indiceActual === -1) {
        return false
      }
      let moduloActual = this.modulos[indiceActual]
      if (!this.comprobarEstadoConBorrado(moduloActual.tipo, reserva)) {
        return false
      }
      switch (moduloActual.tipo) {
        case 'condiciones':
          return true
        case 'contrato':
        case 'pago':
        case 'kyc':
        case 'documentacion': {
          let codigo = this.getModuloCodigo(moduloActual.tipo, reserva)
          return !(codigo === 5 && this.esCliente)
        }
        case 'validacionDocumentacion': {
          let codigoValidacion = this.getModuloCodigo(moduloActual.tipo, reserva)
          return codigoValidacion === 5 && (this.esComercial || this.esAdministrador)
        }
        case 'pbc': {
          let codigoPbc = this.getModuloCodigo(moduloActual.tipo, reserva)
          return (codigoPbc === 5 || codigoPbc === 6) && (this.esPbc || this.esAdministrador)
        }
      }
    },
    comprobarEstadoAnterior (tipo, reserva) {
      let indiceActual = this.modulos.findIndex(x => x.tipo === tipo)
      let moduloActual = this.modulos[indiceActual]
      // recorremos los módulos desde el primero hasta el actual
      // al encontrar uno que no esté terminado se lanza una exception
      // si están todos terminados se devuelve true al final
      for (let i = 0; i < indiceActual; i++) {
        let modulo = this.modulos[i]
        let kycDocumentacion = moduloActual.tipo === 'documentacion' && modulo.tipo === 'kyc'
        if (kycDocumentacion) {
          let codigoKyc = this.getModuloCodigo(modulo.tipo, reserva)
          // si el módulo actual es documentación y el que estamos comprobando es kyc
          // hay que comprobar el estado 'rellenado' en kyc
          if (codigoKyc !== 3 && !this.moduloTerminado(modulo.tipo, reserva)) {
            return false
          }
        } else if (!this.moduloTerminado(modulo.tipo, reserva)) {
          return false
        }
      }
      return true
    },
    esPbcDenegado (tipo, reserva) {
      if (tipo === 'pbc') {
        return reserva.estadoPbc.codigoEstadoPbc === 91 || reserva.estadoPbc.codigoEstadoPbc === 92
      }
      return false
    },
    moduloTerminado (tipo, reserva) {
      switch (tipo) {
        case 'condiciones':
          return true
        case 'pbc': {
          let codigo = this.getModuloCodigo(tipo, reserva)
          return codigo === 10 || codigo === 11 || codigo === 20
        }
        case 'contrato':
        case 'kyc':
        case 'pago':
        case 'validacionDocumentacion':
        case 'documentacion': {
          let codigo = this.getModuloCodigo(tipo, reserva)
          return codigo === 10 || codigo === 20
        }
      }
    },
    getColorEstado (codigo, tipo = '') {
      let color = 'aceptada'
      switch (codigo) {
        case 1:
        case 2:
          color = 'pendiente'
          break
        case 3:
          if (tipo === 'kyc') {
            color = 'revision'
          } else {
            color = 'pendiente'
          }
          break
        case 5:
        case 6:
          color = 'revision'
          break
        case 10:
        case 11:
        case 20:
          color = 'aceptada'
          break
        case 90:
        case 91:
        case 92:
          color = 'rechazada'
          break
      }
      return color
    },
    getModuloActual (reserva) {
      return reserva.modulosOrden.modulos.findIndex(x => this.getModuloEstado(x.tipo, reserva) !== 'aceptada')
    },
    terminadoPaso (completado) {
      this.cambiadoAlert = false
      if (completado) {
        this.$router.push({name: 'reservas.id', params: {id: this.id, skip: true}})
      } else {
        this.$router.push({name: 'reservas.id', params: {id: this.id}})
      }
    },
    error () {
      this.cambiadoAlert = false
      this.$router.push({name: 'reservas.id', params: {id: this.id}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/modulos.js